import type { ChangelogEntry } from '@/lib/changelog/changelog-types';
import type { ChangelogProductId } from '@/lib/changelog/changelog-sources';
import { apiDelete, apiGet, apiPost, apiPut } from './api-client';

export type ChangelogProductDto = {
  id: ChangelogProductId;
  /** ID numérico na BD (admin create/update). */
  productId?: number;
  slug: string;
  name: string;
  label: string;
  shortLabel: string;
  heroTitle: string;
  heroDescription: string;
};

type ListResponse<T> = { data: T };

export async function getPublicProducts(): Promise<ChangelogProductDto[]> {
  const res = await apiGet<ListResponse<ChangelogProductDto[]>>('/changelog/products');
  return res.data ?? [];
}

export async function getPublicVersions(slug: string): Promise<ChangelogEntry[]> {
  const res = await apiGet<ListResponse<ChangelogEntry[]>>(`/changelog/products/${slug}/versions`);
  return res.data ?? [];
}

export async function getAdminProducts(): Promise<ChangelogProductDto[]> {
  const res = await apiGet<ListResponse<ChangelogProductDto[]>>('/admin/changelog/products', true);
  return res.data ?? [];
}

export async function getAdminVersions(productId: number): Promise<ChangelogEntry[]> {
  const res = await apiGet<ListResponse<ChangelogEntry[]>>(`/admin/changelog/products/${productId}/versions`, true);
  return res.data ?? [];
}

export async function createVersion(input: {
  changelog_product_id: number;
  version: string;
  title: string;
  body?: Record<string, unknown>;
  released_at?: string;
  meta?: Record<string, unknown>;
}): Promise<unknown> {
  const res = await apiPost<{ data: unknown }>('/admin/changelog/versions', input, true);
  return res.data;
}

export async function updateVersion(
  versionId: number,
  patch: Record<string, unknown>
): Promise<unknown> {
  const res = await apiPut<{ data: unknown }>(`/admin/changelog/versions/${versionId}`, patch, true);
  return res.data;
}

export async function deleteVersion(versionId: number): Promise<void> {
  await apiDelete(`/admin/changelog/versions/${versionId}`, true);
}
